document.addEventListener('DOMContentLoaded', () => {
  // Function to toggle favorite status and reorder all favorited items
  const toggleFavorite = (checkbox: HTMLInputElement) => {
    const productId = checkbox.id;
    if (productId) {
      const favorites = JSON.parse(localStorage.getItem('cbs:mortgages:favorites') || '{}');
      favorites[productId] = checkbox.checked;
      localStorage.setItem('cbs:mortgages:favorites', JSON.stringify(favorites));

      const mortgageItemsContainer = document.querySelector('.mortgages__block') as HTMLElement;
      const mortgageItems = Array.from(document.querySelectorAll('.mortgage-item')) as HTMLElement[];

      // Clear the container
      mortgageItemsContainer.innerHTML = '';

      // Reorder favorited items to the top
      mortgageItems.forEach((item) => {
        const itemId = item.querySelector<HTMLInputElement>('.mortgage-item__favourites-input')?.id;
        if (itemId && favorites[itemId]) {
          mortgageItemsContainer.prepend(item);
        } else {
          mortgageItemsContainer.appendChild(item);
        }
      });
    }
  };

  // Set initial favorite status for all items and reorder favorited items to the top
  const setInitialFavoriteStatus = () => {
    const favorites = JSON.parse(localStorage.getItem('cbs:mortgages:favorites') || '{}');
    const mortgageItemsContainer = document.querySelector('.mortgages__block') as HTMLElement;
    const mortgageItems = Array.from(document.querySelectorAll('.mortgage-item')) as HTMLElement[];

    mortgageItems.forEach((item) => {
      const productId = item.querySelector<HTMLInputElement>('.mortgage-item__favourites-input')?.id;
      if (productId && favorites[productId]) {
        mortgageItemsContainer.prepend(item);
      }
    });

    for (const productId in favorites) {
      if (favorites.hasOwnProperty(productId)) {
        const checkbox = document.getElementById(productId) as HTMLInputElement;
        if (checkbox) {
          checkbox.checked = favorites[productId];
        }
      }
    }
  };

  // Toggle favorite status and reorder all favorited items on checkbox change
  document.querySelectorAll<HTMLInputElement>('.mortgage-item__favourites-input').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      toggleFavorite(checkbox);
    });
  });

  setInitialFavoriteStatus();

  // Toggle more information on "Compare all" page
  document.querySelectorAll<HTMLElement>('.mortgage-item__more').forEach((more) => {
    more.setAttribute('aria-label', 'click to expand');
    more.addEventListener('click', () => {
      const headingElement = more.closest('.mortgage-item__heading') as HTMLElement;
      const infoElement = headingElement ? (headingElement.nextElementSibling as HTMLElement) : null;
      const moreText = more.querySelector('.mortgage-item__more-text');
      if (more.classList.contains('active')) {
        more.classList.remove('active');
        more.setAttribute('aria-label', 'Click to expand');
        if (infoElement) infoElement.style.display = 'none';
        if (moreText) moreText.innerHTML = 'See more';
      } else {
        more.classList.add('active');
        more.setAttribute('aria-label', 'Expanded , click to close');
        if (infoElement) infoElement.style.display = 'block';
        if (moreText) moreText.innerHTML = 'See less';
      }
    });
  });
});
